export function estimateAddition(state, candidate, country) {
  if (!state.shippingVerified || state.currency !== 'GBP' || country !== 'GB') return null;
  if (!candidate.singleVariant || candidate.quantityMin !== 1 || candidate.sellingPlans || candidate.preorder) return null;
  if (!Number.isSafeInteger(candidate.price) || candidate.price < 0) return null;
  if (!Array.isArray(state.items) || !state.items.length || state.items.some(i => i.sellingPlan || !i.requiresShipping)) return null;
  if (![state.total, state.discountTotal, state.promoSaving, state.threshold, state.fee].every(Number.isSafeInteger)) return null;
  if (state.total < 0 || state.threshold <= 0 || state.fee < 0 || state.discountTotal !== state.promoSaving) return null;
  const eligible = state.items.filter(i => i.eligible);
  const count = eligible.reduce((n, i) => n + i.quantity, 0);
  if (count !== state.eligibleCount) return null;
  const savings = items => items.reduce((n, i) => n + Math.round(i.original * .1), 0);
  const existingExpected = state.offerEnabled && count >= 2 ? savings(eligible) : 0;
  if (Math.abs(existingExpected - state.promoSaving) > eligible.length) return null;
  if (existingExpected > 0 && state.promoSaving === 0) return null;
  const nextCount = count + (candidate.eligible ? 1 : 0);
  const nextEligible = [...eligible, ...(candidate.eligible ? [{original: candidate.price}] : [])];
  const nextSaving = state.offerEnabled && nextCount >= 2 ? savings(nextEligible) : 0;
  const nextTotal = state.total + state.promoSaving + candidate.price - nextSaving;
  const shipping = total => total >= state.threshold ? 0 : state.fee;
  return nextTotal + shipping(nextTotal) - state.total - shipping(state.total);
}

if (typeof document !== 'undefined') {
  let confirmedCountry = null;
  try { confirmedCountry = sessionStorage.getItem('fauniva_delivery_country'); } catch {}
  document.addEventListener('submit', event => {
    if (!event.target.matches('.shipping-estimator__form')) return;
    const selection = event.target.querySelector('[name="address[country]"]')?.value;
    confirmedCountry = selection === 'United Kingdom' || selection === 'GB' ? 'GB' : 'other';
    try { sessionStorage.setItem('fauniva_delivery_country', confirmedCountry); } catch {}
    document.querySelectorAll('fauniva-cart-guide').forEach(guide => guide.update());
  }, true);

  class FaunivaCartGuide extends HTMLElement {
    connectedCallback() {
      try { this.state = JSON.parse(this.querySelector('[data-fauniva-cart-state]').textContent); }
      catch { return; }
      this.abort = new AbortController();
      document.addEventListener('cart:change', () => {
        this.querySelectorAll('[data-fauniva-estimate], [data-fauniva-estimate-note]').forEach(e => e.hidden = true);
      }, {signal: this.abort.signal});
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); }
    update() {
      if (!this.state) return;
      const country = confirmedCountry || this.state.country;
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style: 'currency', currency: 'GBP'});
      let shown = false;
      this.querySelectorAll('[data-fauniva-candidate]').forEach(card => {
        const target = card.querySelector('[data-fauniva-estimate]');
        if (!target) return;
        const d = card.dataset;
        const delta = estimateAddition(this.state, {
          price: Number(d.price), eligible: d.eligible === 'true', singleVariant: d.singleVariant === 'true',
          quantityMin: Number(d.quantityMin), sellingPlans: Number(d.sellingPlans), preorder: d.preorder === 'true'
        }, country);
        target.hidden = delta === null;
        if (delta !== null) {
          const label = delta < 0 ? this.state.labels.lower : this.state.labels.delta;
          target.textContent = label.replace(/\{\{\s*amount\s*\}\}/g, money.format(Math.abs(delta) / 100));
          shown = true;
        }
      });
      const note = this.querySelector('[data-fauniva-estimate-note]');
      if (note) note.hidden = !shown;
    }
  }
  if (!customElements.get('fauniva-cart-guide')) customElements.define('fauniva-cart-guide', FaunivaCartGuide);
}
